import * as React from "react"
import { Fragment, useEffect, useState } from "react"
import { Route, HashRouter, Switch } from "react-router-dom"
import * as toastr from "toastr"
import { ThemeProvider } from "styled-components"

import UserContext from "Placements/User.context"
import PageViewUtil from "Placements/Utils/PageView.util"
import ScrollToTop from "Placements/Components/ScrollToTop"

import MainTheme from "Placements/Themes/Main.theme"
import DyslexiaTheme from "Placements/Themes/Dyslexia.theme"
import NightTheme from "Placements/Themes/Night.theme"
import HighTheme from "Placements/Themes/High.theme"
import GlobalStyle from "Placements/Styles/Global.style"
import getConfig from "Placements/Utils/GetRequestConfig.util"
import Header from "Placements/Components/Header"
import API from "Placements/API"
import { userDataLayer } from "./Utils/DataLayer"


const filterWithPageComponent = ({ page }: any) => !!page
const getKeystone = ({ keystone }: any) => keystone
const by = (property: string) => (config: any) => config[property]

const Redirect = (redirect: any, profiles: any) => {

    if (redirect) {
        window.location.href = `#${redirect}`
    } else {
        window.location.href = "#/welcome"
    }
}

const PlacementsContainer = ({ configs }: { configs: Array<PageConfig> }) => {

    const [userData, setUserData] = useState(JSON.parse(localStorage.getItem("dataPl")))
    const [contrast, setContrast] = useState(localStorage.getItem("contrast"))
    const [reading, setReading] = useState(localStorage.getItem("reading"))

    useEffect(() => {
        if (reading) {
            //localStorage.setItem("reading", reading)
        }
    }, [reading])

    useEffect(() => {
        if (contrast) {
            //localStorage.setItem("contrast", contrast)
        }
    }, [contrast])

    useEffect(() => {
        if (
            window.location.hash.indexOf("#/forgot-password") > -1
            || window.location.hash.indexOf("#/press") > -1
            || window.location.hash.indexOf("#/redefine-senha") > -1
            || window.location.hash.indexOf("#/confirm-email") > -1
            || window.location.hash.indexOf("#/register-user") > -1
            || window.location.hash.indexOf("#/server-error") > -1
            || window.location.hash.indexOf("#/waiting") > -1
        ) { }
        else if (!userData) {
            if (window.location.hash.indexOf("#/login") === -1) {
                window.location.href = "#/login"
            }
        }
    }, [userData])

    useEffect(() => {
        if (userData && userData.usuario.Id_Usuario)
            userDataLayer.ResendUserId(userData.usuario.Id_Usuario);
    }, [userData]);


    const hasShowHeader = (keystone: string) => !(configs.filter(by("disableHeader")).map(getKeystone).indexOf(keystone) > -1)

    const handleUpdateUserData = (userDataUpdated: any) => {

        const newUserData = { ...userData, ...userDataUpdated }
        localStorage.setItem("dataPl", JSON.stringify(newUserData))
        setUserData(newUserData)
    }

    const handleLogin = async (userData: any) => {

        if (userData) {
            setUserData(userData)

            const { location: { hash } } = window

            if (userData.usuario.Id_perfil === 1) {

                Redirect("/admin/test-list", userData.profiles)

            } else {

                Redirect("/welcome", userData.profiles)

            }

        } else {
            toastr.error(`Invalid username or password!`, "Error!")
        }
    }

    const updateDataUser = async () => {
        setUserData({ ...userData })
        const { apelido, idUsuario, passwordForLogin } = userData
        if (passwordForLogin) {
            try {
                await API.Dashboard.Put({ idUsuario })
                const responseAuth = await API.Auth.Get({ id: apelido, senha: passwordForLogin, mobile: false })
                const { data } = responseAuth
                const authToken = responseAuth.headers["auth-token"]
                const responseUsuario = await API.Usuario.Get({ id: idUsuario }, getConfig())
                const newUserData = { ...data, nome: responseUsuario.data.nome_aluno }


                handleLogin(newUserData)

                localStorage.setItem("AuthorizationPl", authToken)
                localStorage.setItem("dataPl", JSON.stringify(newUserData))

            } catch (erro) {
                toastr.error("Unable to login", "Error!")
            }
        } else {
            toastr.warning("Fill in all required fields in your profile")
        }
    }

    const handleLogout = () => {
        setContrast("regular")
        setReading("regular")

        localStorage.removeItem("AuthorizationPl")
        localStorage.removeItem("dataPl")
        //localStorage.removeItem("contrast")
        //localStorage.removeItem("reading")
        setUserData(undefined)
    }

    const handleRenderContent = ({ keystone, path, page }: any) => {
        return (routeProps: any) => {
            PageViewUtil()

            if (
                userData
                || (
                    path
                    && (
                        path === "/login"
                        || path.indexOf("/forgot-password") > -1
                        || path.indexOf("/press") > -1
                        || path.indexOf("/redefine-senha") > -1
                        || path.indexOf("/confirma-email") > -1
                        || path.indexOf("/register-user") > -1
                        || path.indexOf("/server-error") > -1
                        || path.indexOf("/waiting") > -1
                    )
                )
            ) {

                if (path && path.includes("/admin/")) {
                    if (userData.usuario.Id_perfil !== 1 &&
                        userData.usuario.Id_perfil !== 3
                    ) {
                        window.location.href = "#/"
                        return;
                    }
                }

                return <Fragment>
                    <GlobalStyle />
                    {
                        userData && hasShowHeader(keystone) &&
                        <Header
                            configs={configs}
                            contrast={contrast}
                            reading={reading}
                            onLogout={handleLogout}
                            onChangeContrast={(contrast: string) => setContrast(contrast)}
                            onChangeReading={(reading: string) => setReading(reading)}
                            keystones={[]}
                        />
                    }


                    <main>
                        {
                            React.createElement(page, {
                                onLogin: handleLogin,
                                onLogout: handleLogout,
                                onUpdateUserData: handleUpdateUserData,
                                ...routeProps
                            }, null)
                        }
                    </main>
                </Fragment>
            } else if (path && path == "/forgot-password") {
                window.location.href = "#/forgot-password"
            } else if (path && path == "/waiting") {
                window.location.href = "#/waiting"
            } else if (path && path == "/server-error") {
                window.location.href = "#/server-error"
            } else if (path && path.includes("/redefine-senha")) {
            } else if (path && path == "/confirma-email") {
                window.location.href = "#/confirma-email"
            } else if (path && path == "/register-user") {
                window.location.href = "#/register-user"
            } else {
                const { location: { pathname, search } } = routeProps
                if (pathname == "/") {
                    window.location.href = "#/login"
                } else {
                    window.location.href = `#/login?redirect=${pathname}${search}`
                }
                return <Fragment />
            }
        }
    }

    const getTheme = () => {
        const theme = {
            main: MainTheme
        }

        if (reading === "dyslexia") {
            theme.main = { ...theme.main, ...DyslexiaTheme }
        }

        if (contrast === "night") {
            theme.main = { ...theme.main, ...NightTheme }
        }

        if (contrast === "high") {
            theme.main = { ...theme.main, ...HighTheme }
        }

        return theme
    }


    return <UserContext.Provider value={userData}>
        <HashRouter>
            <ThemeProvider theme={getTheme()}>
                <Switch>
                    {configs
                        .filter(filterWithPageComponent)
                        .map((config, key) => {
                            return <ScrollToTop {...config} key={key}>
                                <Route key={key} exact path={config.path} render={handleRenderContent(config)} />
                            </ScrollToTop>
                        })
                    }
                </Switch>
            </ThemeProvider>
        </HashRouter>
    </UserContext.Provider >
}
export default PlacementsContainer


